import { BrowserRouter as Router, Route, Routes, useParams, useSearchParams } from 'react-router-dom'
import {  useContext, useEffect, useRef } from 'react'
import { Consulta } from './sec_consulta'
import CasoContext from './store/CasoContext'
import ConsultaContextState from './store/ConsultaContextState'
import ConsultaTicketContext from './store/ConsultaTicketContext'
import './App.css'

// Props interface for ConsultaWithContext
interface ConsultaWithContextProps {
  initialTicket?: string
}

// Props interface for ConsultaWithTicketContext
interface ConsultaWithTicketContextProps {
  ticketNumber?: string
}

// Wrapper component for Consulta with its context
// eslint-disable-next-line react/prop-types
const ConsultaWithContext: React.FC<ConsultaWithContextProps> = ({ initialTicket = '' }) => {
  const [searchParams] = useSearchParams()
  const ticketParam = searchParams.get('ticket')
  const effectiveTicket = initialTicket || ticketParam || ''

  return (
    <ConsultaContextState>
      <ConsultaWithTicketContext ticketNumber={effectiveTicket} />
    </ConsultaContextState>
  )
}

// Component that sets the ticket number in the context
// eslint-disable-next-line react/prop-types
const ConsultaWithTicketContext: React.FC<ConsultaWithTicketContextProps> = ({ ticketNumber = '' }) => {
  const consultaContext = useContext(ConsultaTicketContext)
  const initializedRef = useRef(false)

  useEffect(() => {
    // Only set the ticket number if it hasn't been initialized yet
    if (consultaContext && ticketNumber && !initializedRef.current) {
      consultaContext.updateField('numeroTicket', ticketNumber)
      initializedRef.current = true
    }
  }, [consultaContext, ticketNumber])

  return <Consulta />
}

// Component to handle direct ticket number in URL
const ConsultaWithTicket: React.FC = () => {
  const { ticketNumber } = useParams<{ ticketNumber: string }>()

  return <ConsultaWithContext initialTicket={ticketNumber || ''} />
}

function App() {
  const context = useContext(CasoContext)
  return (
    <div className="App" style={{backgroundColor: context?.caso.appColor}}>
      <Router>
        <Routes>
          <Route path="/" element={<ConsultaWithContext />} />
          <Route path="/consulta" element={<ConsultaWithContext />} />
          <Route path="/consulta/:ticketNumber" element={<ConsultaWithTicket />} />
          <Route path="/*" element={<ConsultaWithContext />} />
        </Routes>
      </Router>
      {/* Comentario  */}
    </div>
  )
}

export default App
